angular.module(NgAppName).component('crBuyers', {
	templateUrl: 'crBuyers.html',
	bindings: {
		isMobile: '<',
		getAgentsRpc: '@',
		getPopupRpc: '@',
		maxBuyers: '<',
		showAgentsButton: '<',
		showAgentsTitle: '<',
		showAgentsTable: '<',
	},
	controller: ['crResourcesService', 'PubSub', '$element', '$timeout', '$window', function(crResourcesService, PubSub, $element, $timeout, $window) {
		var ctrl = this;
		this.placeholderBuilding = 'Enter building name / address';
		this.selectBuilding = function(building) {
			this.buildinId = building.id;
			this.getBuyers();
		};
		this.setData = function(data) {
			var ctrl = this;
			ctrl.building = data.building;
			ctrl.building.info = ctrl.building.building_street_corner === "" ? ctrl.building.building_hood :
				ctrl.building.building_street_corner + ', ' + ctrl.building.building_hood;
			ctrl.buyers = data.buyers.length > 0 ? data.buyers : null;
			ctrl.sort = data.tableTools.sortings.sort;
			ctrl.dir = data.tableTools.sortings.dir;
			ctrl.total = data.tableTools.pagination.total;
			ctrl.createBuyersIcons();
		};

		this.createBuyersIcons = function() {
			this.iconsList = [];
			for (var i = 0; i < this.maxBuyers; i++) {
				var icon = {};
				icon.isActive = false;
				this.iconsList.push(icon);
			}
		};

		this.selectBuyer = function(buyer) {
			if (this.buyerWithError) {
				this.buyerWithError.withError = false;
				this.buyerWithError = null;
			}
			if (this.buyersAmount < this.maxBuyers) {
				buyer.selected = !buyer.selected;
				if (buyer.selected) {
					this.buyersAmount ++;
				} else {
					this.buyersAmount --;
				}
				this.createBuyersIcons();
				this.rebuildIconsList();
			} else if (buyer.selected) {
				buyer.selected = !buyer.selected;
				this.buyersAmount --;
				this.createBuyersIcons();
				this.rebuildIconsList();
			} else {
				buyer.withError = true;
				this.buyerWithError = buyer;
			}
		};

		this.rebuildIconsList = function() {
			for (var i = 0; i < this.buyersAmount; i++) {
				this.iconsList[i].isActive = true;
			}
		};

		this.sortTable = function(sort) {
			if (this.sort === sort) {
				this.dir = (this.dir === '1') ? '2' : '1';
			} else {
				this.sort = sort;
				this.dir = '1';
			}
			this.getBuyers(!ctrl.displayShowAllButton, true);
		};

		this.getBuyers = function(showAll, keepShowAllState) {
			var ctrl = this;
			if (this.isMobile) {
				jQuery(window).trigger('spinnerShow');
			} else {
				ctrl.isLoading = true;
			}
			var url = this.getAgentsRpc + '?building_id=' + this.buildinId;
			url += showAll ? '&show_all=1' : '&show_all=0';
			url += (this.sort && this.dir) ? '&sort=' + this.sort + '&dir=' + this.dir : '';
			var crDataPromise = crResourcesService.getDataObject(url);
			this.buyersAmount = 0;
			crDataPromise.then(function(data) {
				ctrl.setData(data);
				if (ctrl.isMobile) {
					jQuery(window).trigger('spinnerHide');
					$timeout(function() {
						ctrl.stickAtTop();
					});
				} else {
					ctrl.isLoading = false;
				}
				if (!keepShowAllState) {
					ctrl.displayShowAllButton = !showAll && ctrl.total > data.tableTools.pagination.rowsPerPage;
				}

				$timeout(() => {
					if (typeof ScrollToElement !== 'undefined') {
						new ScrollToElement();
					}
				});
			});
		};

		this.sendBuyers = function() {
			var dataRpc = this.getPopupRpc + '?building_id=' + this.buildinId + '&buyer=1';
			angular.forEach(this.buyers, function(buyer) {
				if (buyer.selected) {
					dataRpc += "&buyer_id[]=" + buyer.buyerId;
				}
			});
			if (!isMobile) {
				var _el = $element[0].getElement('.w_blimp_form');
				angular.element(_el).attr('data-rpc', dataRpc);
				new Blimp.Form(_el, {
					draggable: true,
					show_veil: true,
					replace_by_result: true,
					onFormSuccess: function(context, data) { 
						if (data && data.RPCFormReusableContact_FORMSUMMARY 
							&& data.RPCFormReusableContact_FORMSUMMARY[0] 
							&& data.RPCFormReusableContact_FORMSUMMARY[0].status === true
							&& data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign) {
							crGtag.track(data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.send_to, data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.value);
						}
					}
				});
				_el.fireEvent('click');
			} else {
				this.mobileBlimp = jQuery('[data-widget=AlertEmail]');
				if (this.mobileBlimp.size()) {
					this.getMobileContactForm(dataRpc);
				}
			}
		};

		this.getMobileContactForm = function(url) {
			var ctrl = this;
			jQuery(window).trigger('spinnerShow');
			var crDataPromise = crResourcesService.getDataObject(url);
			crDataPromise.then(function(data) {
				ctrl.mobileBlimp['AlertEmail']('handleBlimpResponse', data);
				jQuery(window).trigger('spinnerHide');
			});
		};
		this.stickAtTop = function() {
			var $win = angular.element($window);
			var initOffset;
			var $elToStick = angular.element($element[0].querySelector('.table-title .icons'));
			$win.on('scroll', function(e) {
				if ($win.scrollTop() >= $elToStick.offset().top && !initOffset) {
					initOffset = $elToStick.offset().top;
					$elToStick.addClass('_stick');
				} else if ($win.scrollTop() < initOffset) {
					$elToStick.removeClass('_stick');
					initOffset = null;
				}
			});
		};


		this.contactBuyers = (buildingName) => {
			PubSub.publish('cr-contact-buyers', {buildingName});
		};
	}]
});
